<template>
  <div class="rates">
    <img src="/static/img/icons/delete.svg" class="delete-icon" 
      @click="deleteInvestmentRate(rateObject.id)"
    />
    
    <b-field>
      <b-input placeholder="Заголовок" required v-model="rateObject.title" 
        @change="updateInvestmentRate(rateObject)"
      ></b-input>
    </b-field>
    
    <b-field>
      <b-input placeholder="Описание" type="textarea" required 
        v-model="rateObject.description" @change="updateInvestmentRate(rateObject)"
      ></b-input>
    </b-field>

    <b-field>
      <Editor v-model="text" :editorToolbar="customToolbar" v-bind:id="`e${rateObject.id}`"/>
    </b-field>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { VueEditor as Editor } from 'vue2-editor'
  import deepcopy from 'deepcopy'

  export default {
    name: 'Rate',
    data () {
      return {
        text: '',
        customToolbar: [
          ['bold', 'italic', 'underline'],
          [{'list': 'ordered'}, {'list': 'bullet'}],
          [{'align': ''}, {'align': 'center'}, {'align': 'right'}, {'align': 'justify'}],
          ['link']
        ]
      }
    },
    computed: {
      rateObject () {
        if (this.rate) {
          this.text = this.rate.text
          return deepcopy(this.rate)
        }
      }
    },
    props: {
      rate: {
        type: Object,
        required: true
      }
    },
    methods: {
      ...mapActions(['deleteInvestmentRate', 'updateInvestmentRate'])
      // handleUpdate (object) {
      //   Object.assign(this.rate, )
      // }
    },
    components: { Editor },
    watch: {
      text () {
        this.rateObject.text = this.text
        this.updateInvestmentRate(this.rateObject)
      }
    }
  }
</script>

<style scoped>
.rates {
  width: 100%;
  position: relative;
  margin: 20px 0px;
}
.delete-icon {
  top: 12px;
  right: 12px;
}
.el-select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// InvestmentRate.vue?2c6c612c